// extracted by mini-css-extract-plugin
module.exports = {"container":"PageContainer_container__WNwGK"};